export const EQUAL = 'EQ';
export const NOT_EQUAL = 'NEQ';
export const LESS_THAN = 'LT';
export const LESS_THAN_OR_EQUAL = 'LTE';
export const GREATER_THAN = 'GT';
export const GREATER_THAN_OR_EQUAL = 'GTE';
export const LIKE = 'LIKE';
